import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import purchaseModule from './purchase'
import requestModule from './request'
import alertMessageModule from './alertMessage'
import $ from 'jquery';
Vue.use(Vuex)
const APP_API_URL = window.ROE_APP_API || window.BaseUrl.VUE_APP_API;
const baseAuthURL = `${APP_API_URL}/auth`;
const baseQuotationURL = `${APP_API_URL}/Quotation`;
const baseOrderURL = `${APP_API_URL}/Order`;
const baseQualityURL = `${APP_API_URL}/Quality`;
const baseRequestMasterURL = `${APP_API_URL}/RequestMaster`;
const afterGetUser = (context , resp) =>{
  const ssoResp = resp.data;
  if(ssoResp && ssoResp.loginAccount){
    ssoResp.loginAccount.allowRouterNameList = ssoResp.allowRouterNameList;
    context.commit('set',  ['loginAccount', ssoResp.loginAccount ]);     
    let userType = ssoResp.loginAccount.userType;    
    let isEmp =false;
    if('Employee' === userType){
      isEmp =true;
    }else if('Member' === userType){
      isEmp =false;
    }
    context.commit('set',  ['isEmployee', isEmp ]);
    let isAdmin = ssoResp.loginAccount.isAdmin;   
    if(isAdmin === true){
      context.commit('set',  ['isSystemAdmin', true ]);
    }

    let isPurchaserSuperior = ssoResp.loginAccount.isPurchaserSuperior;   
    if(isPurchaserSuperior === true){
      context.commit('set',  ['isPurchaserSuperior', true ]);
    }

    let isRequestOnly = ssoResp.loginAccount.isRequestOnly;   
    if(isRequestOnly === true){
      context.commit('set',  ['isRequestOnly', true ]);
    }

    let isAuditSuperior = ssoResp.loginAccount.isAuditSuperior;   
    if(isAuditSuperior === true){
      context.commit('set',  ['isAuditSuperior', true ]);
    }

    let isRequestSystemUser = ssoResp.loginAccount.isRequestSystemUser;   
    if(isRequestSystemUser === true){
      context.commit('set',  ['isRequestSystemUser', true ]);
    }
  }
  if(ssoResp){
    if(ssoResp.redirectUrl){
      context.commit('set',  ['redirectUrl', ssoResp.redirectUrl ]);            
    }
    if(ssoResp.returnUrl){
      context.commit('set',  ['returnUrl', ssoResp.returnUrl ]);            
    }
    if(ssoResp.statusMessage){
      context.commit('set',  ['loginStatusMessage', ssoResp.statusMessage ]);            
    }
  }
};
const loadCacheStoreData = (context , url , cacheKey) =>{
  const cacheStoreData = context.getters.cacheStoreData;
  if(!(cacheStoreData && cacheStoreData[cacheKey])) {
    return axios.get(url, {}).then((response) => {
      cacheStoreData[cacheKey] = response.data;
      //context.commit('setCache', ['cacheStoreData', cacheStoreData ] );    
      return cacheStoreData[cacheKey];
    });
  }else{
    return new Promise((resolve) => {
      resolve(cacheStoreData[cacheKey]);
    });
  }
};
export default new Vuex.Store({
    strict: true,
    state: {      
      isLoading: false,
      lang: null,// 語系
      // sidebar 縮放
      sidebarShow: 'responsive',
      sidebarMinimize: false,     
      loginAccount: null,
      redirectUrl : '',
      returnUrl : '', 
      loginStatusMessage: '', 
      isEmployee:false,
      isSystemAdmin:false,
      isPurchaserSuperior: false,
      isRequestOnly: false,
      isAuditSuperior: false,   //  稽核主管
      isRequestSystemUser: false,   //  XX廠詢價的使用者
      dialogConfig: {msgTitle:'',msgHeader:'',msgText:''},
      cacheStoreData :{},      
    },
    actions: {
      updateLoading(context, payload) {
        context.commit('LOADING', payload);
      },
      login(context, payload) {
        const url = `${baseAuthURL}/ssologin`        
        context.commit('set', ['loginAccount', null ] );
        return axios.post(url, payload).then((response) => {
            let resp = response
            //for UI developer 
            // if(process.env && process.env.VUE_APP_UI_DEVELOPER_IGNORE_LOGIN === 'Y'){
            //     resp = {data :  {"status":0,"statusMessage":"","redirectUrl":null,"loginAccount":{"account":"10005346","accountName":"黃惠珠","funcName":"MIS資訊","companyName":null,"userType":"Employee","accGuid":"17c15203-55d5-4354-9bf2-ac1edebbda0f","roleId":"MIS資訊","vendorId":"Radiant","userFactory":"KH","isAdmin":true},"allowRouterNameList":["CheckScore","QFM","QFMedit","QDFMForm","RequestSearchList","SupplierSearchList","PurchaseSearchList","PurchaseEdit","OrderSearch","Report","OrderStatus","ChangeOrder","ChangeOrderInformation","ScheduleLine","Statement","Account","Drawing","PlanMasterFile","PlanMasterFile_Information","TrialProduction","Information","ItemInformation","TentativePreparationReport","TentativePreparationReportInformation","COA","COAInformation","JQM","JQMInformation","GeneralTable","GeneralTableInformation","Detail","Element", "QBR"]}}

            //     //  身分 Member 的
            //     // resp = {data :  {"status":0,"statusMessage":"","redirectUrl":null,"loginAccount":{"account":"10005346","accountName":"黃惠珠","funcName":"MIS資訊","companyName":null,"userType":"Member","accGuid":"17c15203-55d5-4354-9bf2-ac1edebbda0f","roleId":"MIS資訊","vendorId":"Radiant","userFactory":"KH","isAdmin":true},"allowRouterNameList":["PurchaseSearchList","PurchaseEdit","OrderSearch","Report","OrderStatus","ChangeOrder","ChangeOrderInformation","ScheduleLine","Statement","Account","Drawing","PlanMasterFile","PlanMasterFile_Information","TrialProduction","Information","ItemInformation","TentativePreparationReport","TentativePreparationReportInformation","COA","COAInformation","JQM","JQMInformation","GeneralTable","GeneralTableInformation","Detail","Element", "QBR"]}}
            //  }            
            afterGetUser(context,resp);
        });

        
      },
      logout(context, payload) {
        const url = `${baseAuthURL}/logout`                
        return axios.get(url, {params: {account : payload} }).then((response) => {
           context.commit('set', ['loginAccount', null ] );            
            let resp = response.data
            if(resp && resp.status === 0){
              context.commit('set', ['redirectUrl', resp.redirectUrl ] );
            }
        });
      },
      currentUser(context) {
        const url = `${baseAuthURL}/currentuser`        
        context.commit('set', ['loginAccount', null ] );        
        return axios.get(url, {}).then((response) => {
          console.log('currentUser', response);
            let resp = response
            //for UI developer 
            // if(process.env && process.env.VUE_APP_UI_DEVELOPER_IGNORE_LOGIN === 'Y'){
            //     resp = {data :  {"status":0,"statusMessage":"","redirectUrl":null,"loginAccount":{"account":"10005346","accountName":"黃惠珠","funcName":"MIS資訊","companyName":null,"userType":"Employee","accGuid":"17c15203-55d5-4354-9bf2-ac1edebbda0f","roleId":"MIS資訊","vendorId":"Radiant","userFactory":"KH","isAdmin":true},"allowRouterNameList":["CheckScore","QFM","QFMedit","QDFMForm","RequestSearchList","SupplierSearchList","PurchaseSearchList","PurchaseEdit","OrderSearch","Report","OrderStatus","ChangeOrder","ChangeOrderInformation","ScheduleLine","Statement","Account","Drawing","PlanMasterFile","PlanMasterFile_Information","TrialProduction","Information","ItemInformation","TentativePreparationReport","TentativePreparationReportInformation","COA","COAInformation","JQM","JQMInformation","GeneralTable","GeneralTableInformation","Detail","Element", "QBR"]}}

            //     //  身分 Member 的
            //     // resp = {data :  {"status":0,"statusMessage":"","redirectUrl":null,"loginAccount":{"account":"10005346","accountName":"黃惠珠","funcName":"MIS資訊","companyName":null,"userType":"Member","accGuid":"17c15203-55d5-4354-9bf2-ac1edebbda0f","roleId":"-QM","vendorId":"KH-M3M004-QM","userFactory":"KH","isAdmin":true},"allowRouterNameList":["PurchaseSearchList","PurchaseEdit","OrderSearch","Report","OrderStatus","ChangeOrder","ChangeOrderInformation","ScheduleLine","Statement","Account","Drawing","PlanMasterFile","PlanMasterFile_Information","TrialProduction","Information","ItemInformation","TentativePreparationReport","TentativePreparationReportInformation","COA","COAInformation","JQM","JQMInformation","GeneralTable","GeneralTableInformation","Detail","Element", "QBR"]}}
            //   }            
            afterGetUser(context,resp);
        });
      },
      showDialog(context, payload) {
        context.commit('set',[ 'dialogConfig' , payload ]);
        $('#dialogModal').modal('show');
      },
      getMemberList(context){        
        const url = `${baseQuotationURL}/GetMemberList`    
        return loadCacheStoreData(context,url, 'memberList');
      },
      getMemberQMList(context){        
        const url = `${baseQualityURL}/GetMemberList`    
        return loadCacheStoreData(context,url, 'memberQMList');
      },
      getPoNoList(context){        
        const url = `${baseQualityURL}/GetPoNoList`    
        return loadCacheStoreData(context,url, 'poNoList');
      },
      getExcelTemplateList(context){
        const url = `${baseQuotationURL}/GetExcelTemplateList`    
        return loadCacheStoreData(context,url, 'excelTemplateList');
      },
      getPhraseKind_04(context){
        const url = `${baseOrderURL}/GetPhraseKind04List`    
        return loadCacheStoreData(context,url, 'PhraseKind_04');
      },
      getVenderList(context){        
        const url = `${baseRequestMasterURL}/GetMemberList`
        return loadCacheStoreData(context,url, 'memberList');
      },
    },
    mutations: {
      LOADING(state, payload) {
        state.isLoading = payload;
      },
      setLang(state, value) {
        state.lang = value;
      },
      toggleSidebarDesktop (state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow);
        state.sidebarShow = sidebarOpened ? false : 'responsive';
      },
      toggleSidebarMobile (state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow);
        state.sidebarShow = sidebarClosed ? true : 'responsive';
      },
      set (state, [variable, value]) {
        state[variable] = value;
      },
    },
    getters: {
      isLoading: state => state.isLoading,
      lang: state => state.lang,
      isLogin: state => {        
        if(state.loginAccount){
          if(state.loginAccount.account){
            return true;
          }
        }
        return false;        
      },
      userInfo : state => state.loginAccount,
      redirectUrl : state => state.redirectUrl,
      returnUrl : state => state.returnUrl,
      loginStatusMessage : state => state.loginStatusMessage,
      dialogConfig: state => state.dialogConfig,
      cacheStoreData: state => state.cacheStoreData,
      isEmployee: state => state.isEmployee,
      isSystemAdmin: state => state.isSystemAdmin,
    },
    modules: {
      purchaseModule,
      requestModule,
      alertMessageModule,
    }
})